import { Injectable } from '@angular/core';
import { serverPort, base_url } from "../../../server/src/config/config";
import { Setting } from "../models/Setting";
import { Http, Response } from "@angular/http";
import 'rxjs/add/operator/map'

@Injectable()
export class SettingsService {

  constructor(private http: Http) {
  }

  createFirm(firm) {
    return this.http.post(`${base_url}/v1/firm`, firm).map((response: Response) => response.json());
  }

  firmDetails() {
    return this.http.get(`${base_url}/v1/firm`).map((response: Response) => response.json());
  }

  createConsignment(consignment) {
    return this.http.post(`${base_url}/v1/consignment`, consignment).map((response: Response) => response.json());
  }

  consignmentList() {
    return this.http.get(`${base_url}/v1/consignment`).map((response: Response) => response.json());
  }

  create(settings: Setting) {
    return this.http.post(`${base_url}/v1/settings`, settings).map((response: Response) => response.json());
  }

  list() {
    return this.http.get(`${base_url}/v1/settings`).map((response: Response) => response.json());
  }

  getSettings() {
    return this.http.get(`${base_url}/v1/settings`).map((response: Response) => response.json());
  }

  putById(_id, settings: Setting) {
    return this.http.put(`${base_url}/v1/settings/${_id}`, settings).map((response: Response) => response.json());
  }

  consignmentNumber() {
    return this.http.get(`${base_url}/v1/consignmentNumber`).map((response: Response) => response.json());
  }
}



// WEBPACK FOOTER //
// /root/production/sne-pro/src/app/services/settings.service.ts